export const EMPTY_FIELD = 'N/A'
